import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContactUs } from '../_models/contactUs';

@Injectable({
  providedIn: 'root',
})
export class ContactUsService {

  constructor(private http: HttpClient) {}

  getContactUs(contactUsProps: ContactUs): Observable<any> {
    return this.http.post('api/contactUs', contactUsProps);
  }
}
